import React from 'react';
import { renderToString } from 'react-dom/server';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import muiTheme from 'mui/base/theme';
import MarkerActiveIcon from 'mui/assets/icons/map-marker-active.svg';
import MarkerFlagshipIcon from 'mui/assets/icons/map-marker-flagship.svg';
import MarkerInActiveIcon from 'mui/assets/icons/map-marker-inactive.svg';
import MarkerBigIcon from 'mui/assets/icons/map-marker-big.svg';
import InfoWindow from '../InfoWindow';

import goToLocationInListTab from '../utils/goToLocationInListTab';
import getLocationSelectionEvent from '../utils/getLocationSelectionEvent';

const initWoosmapMarkers = (
  map,
  locations,
  mapMarkers,
  setMapMarkers,
  metaData,
  onMarkerClick,
  opts,
  selectedLocation,
  showTimeSlots,
) => {
  if (!map || !Array.isArray(locations)) return;
  let _markers = [];
  const { onLocationSelection } = metaData || {};

  // resetting map data
  mapMarkers?.forEach(marker => {
    marker.setMap(null);
  });

  const getMarkerIcon = location => {
    let icon;

    if (opts.hideMarkers) icon = null;
    else if (locations.length === 1) icon = MarkerBigIcon;
    else if (location.flagshipStoreLabel) icon = MarkerFlagshipIcon;
    else icon = MarkerInActiveIcon;

    return icon;
  };

  const infoWindow = new window.woosmap.map.InfoWindow({});

  const infoWindowMapPadding = { left: 0, top: 300 };
  const setInfoWindowContent = location => {
    const infoWindowComponent = renderToString(
      <MuiThemeProvider theme={muiTheme}>
        <InfoWindow location={location} metaData={metaData} />
      </MuiThemeProvider>,
    );

    infoWindow.setContent(infoWindowComponent);

    // adding this event because onClick in infoWindow doesn't work
    // so we have to manually add the event listener for this
    // https://stackoverflow.com/questions/53615413/how-to-add-a-button-in-infowindow-with-google-maps-react
    infoWindow.addListener('domready', () => {
      const chooseLocationBtn = document.getElementById('booking-funnel-choose-location-btn');
      if (chooseLocationBtn)
        chooseLocationBtn.addEventListener('click', event => {
          if (showTimeSlots) goToLocationInListTab(event, location, onMarkerClick);
          else getLocationSelectionEvent(event, location, onLocationSelection);
        });
    });

    infoWindow.setOffset({
      x: 0,
      y: -50,
    });
  };

  let markerSelected;
  let markerLocationSelected;
  const handleMarkerSelection = (marker, location) => {
    if (markerSelected) {
      markerSelected.setIcon(getMarkerIcon(markerLocationSelected));
      markerSelected.setZIndex(1);
    }
    markerSelected = marker;
    markerLocationSelected = location;
    marker.setIcon(MarkerActiveIcon);
    marker.setZIndex(2);

    if (opts.infoWindows) {
      setInfoWindowContent(location);
      infoWindow.open(map, marker.getPosition());
      map.panTo(marker.getPosition(), infoWindowMapPadding, true);
    }
  };
  const addMarkerClickEvent = (marker, location) => {
    marker.addListener('click', () => {
      onMarkerClick(location);
      handleMarkerSelection(marker, location);
    });
  };

  // setting new geo data for map
  locations.forEach(location => {
    if (!!location?.latitude && !!location?.longitude) {
      const position = {
        lat: location.latitude,
        lng: location.longitude,
      };
      const marker = new window.woosmap.map.Marker({
        position: position,
        icon: getMarkerIcon(location),
        map: map,
      });
      addMarkerClickEvent(marker, location);
      // to check in the start if there is an already selected location (e.g. from booking funnel)
      // then make it the selected and an active icon
      if (location.code === selectedLocation?.code) handleMarkerSelection(marker, location);

      _markers.push(marker);
    }
  });

  setMapMarkers(_markers);
};

export default initWoosmapMarkers;
